import type { VariantProps } from 'class-variance-authority';
import { Link, type LinkProps } from 'react-router';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * 本文や表のセルの中の遷移。
 *
 * 色は brand-700 (主要アクションと同じ)、下線は付ける。表のセルでは
 * 下線だけが「押せる」の手掛かりになるので、hover まで隠さない。
 */
export function TextLink({ className, ...props }: LinkProps) {
  return (
    <Link
      className={cn('text-brand-700 underline underline-offset-2 hover:text-brand-800', className)}
      {...props}
    />
  );
}

/**
 * ボタンの見た目をした遷移。
 *
 * 行末の「この行から次の画面へ」に使う。既存の表は行末に Button を置いて
 * いるので、遷移だけ別の形にしない (CSV出力の `<a>` と同じ作り)。
 */
export function LinkButton({
  className,
  variant,
  size,
  ...props
}: LinkProps & VariantProps<typeof buttonVariants>) {
  return <Link className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}
